module.exports = __webpack_public_path__ + "static/img/2_1_3.b157ed47.jpg";